export const CONSULTAR_REPORTE_PATH = '/report';